import { Spacer } from 'app/member/layouts/generic';
import { Button } from 'app/shared/button';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { Icon } from 'assets/icons';
import { useUserService } from 'hooks/api/iam/user';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { urls } from 'services/_url';
import { useParams } from 'react-router-dom';

export const AgentProfileDetails = () => {
  const { id } = useParams();
  const { fetchUsers, updateUserData } = useUserService();

  const [user, setUser] = useState(null);
  const [form_data, setFormData] = useState({});
  const [mode, setMode] = useState('view');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user) return;

    setFormData({
      email: user.email || '',
      firstname: user.firstname || '',
      lastname: user.lastname || '',
      code: user.code || ''
    });
  }, [user]);

  const code = user?.code || '';
  const percentage = user?.percentage || '';

  const copyLink = () => {
    navigator.clipboard
      .writeText(`${urls.landing}/register/${code}`)
      .then(() => toast.info('Copied.'))
      .catch((e) => e);
  };

  const handleInputChange = (property = '', value = '') => {
    if (!property || !value) return;
    setFormData((curr_data) => ({ ...curr_data, [property]: value }));
  };

  useEffect(() => {
    fetchUsers({ query_string: `id=${id}` }).then(({ users: [user] }) => {
      if (!user) return toast.error('Agent not found');
      setUser(user);
    });
  }, [id]);

  const submit = async () => {
    const data = {
      ...form_data,
      old_code: code,
      referral: { ...user.referral, code: form_data.code }
    };
    setSaving(true);

    const result = await updateUserData(id, { data });
    if (result) {
      toast.success('Update successful');
      setUser((prev) => ({ ...prev, ...data }));
      setMode('view');
    }
    setSaving(false);
  };

  return (
    <>
      <BasicInfoSection
        title="Basic details"
        icon={<Icon name="edit" onClick={() => setMode('edit')} />}
      >
        {mode === 'view' ? (
          <>
            <DetailItem title="First name">{user?.firstname}</DetailItem>
            <DetailItem title="last name">{user?.lastname}</DetailItem>
            <DetailItem title="Email address">{user?.email}</DetailItem>
            <DetailItem title="Referral code">{user?.code}</DetailItem>
            <DetailItem title="Earning Percentage">{user?.percentage}</DetailItem>
            <Button type="secondary" text="Copy referral link" onClick={copyLink} />
          </>
        ) : (
          <>
            <DetailItem title="First name">
              <SimpleInput
                value={form_data.firstname}
                onInput={(v) => handleInputChange('firstname', v)}
              />
            </DetailItem>
            <DetailItem title="last name">
              <SimpleInput
                value={form_data.lastname}
                onInput={(v) => handleInputChange('lastname', v)}
              />
            </DetailItem>
            <DetailItem title="Email address">
              <SimpleInput value={form_data.email} onInput={(v) => handleInputChange('email', v)} />
            </DetailItem>
            <DetailItem title="Referral code">
              <SimpleInput value={form_data.code} onInput={(v) => handleInputChange('code', v)} />
            </DetailItem>
            <DetailItem title="Earning Percentage">{percentage}</DetailItem>
            <Spacer multiple={4} />
            <Button text="Save Changes" loading={saving} onClick={submit} />
            <Spacer multiple={4} />
            <Button text="Cancel" type="secondary" onClick={() => setMode('view')} />
          </>
        )}
      </BasicInfoSection>
    </>
  );
};
